import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueSocialSharing from "vue-social-sharing";
import i18n from "./plugins/i18n";

import Footer from "./components/Footer";
import Loader from "./components/app/Loader";

import Vuelidate from "vuelidate";
import VueMeta from "vue-meta";
import VueIntro from "vue-introjs";

import uppercase from "./filters/uppercase.filter";
import cutTitle from "./filters/cutTitle.filter";

import "intro.js/introjs.css";

Vue.config.productionTip = false;

Vue.filter("toUppercase", uppercase);
Vue.filter("toCut", cutTitle);

Vue.use(Vuelidate);
Vue.use(VueMeta);
Vue.use(VueIntro, {
  waitTimeout: 1000
});

Vue.component("Footer", Footer);
Vue.component("Loader", Loader);

Vue.use(VueSocialSharing);

i18n.locale = localStorage.getItem("curLang")?.toLowerCase();

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
